import { Component, Input } from '@angular/core';

import { CaGroup } from '../../../core';

@Component({
    selector: 'cmps-ca-evaluation-result-phase-header',
    templateUrl: './phase-header.component.html',
})
export class PhaseHeaderComponent {
    @Input()
    group: CaGroup;
}
